module.exports = __webpack_public_path__ + "img/ZB53详情页_12.64cbe7b8.jpg";